import { router, useFocusEffect } from "expo-router";
import { useCallback, useState } from "react";
import { Pressable, Text, View } from "react-native";

import { fetchCorrectionRequests, type RnCorrectionRequest } from "@/lib/correction-requests";

export function CorrectionQuestionsBadge({ visitId }: { visitId?: string }) {
    const [requests, setRequests] = useState<RnCorrectionRequest[]>([]);
    useFocusEffect(
        useCallback(() => {
            let mounted = true;
            void fetchCorrectionRequests()
                .then((rows) => {
                    if (mounted) {
                        setRequests(
                            rows.filter(
                                (r) => !r.answeredAt && (!visitId || String(r.visitId) === visitId)
                            )
                        );
                    }
                })
                .catch(() => {
                    /* The next focus retries. */
                });
            return () => {
                mounted = false;
            };
        }, [visitId])
    );
    const visitIds = [...new Set(requests.map((r) => r.visitId))];
    if (!visitIds.length) {
        return null;
    }
    return (
        <View style={{ gap: 8, marginVertical: 12 }}>
            {visitIds.map((id) => (
                <Pressable
                    key={id}
                    accessibilityRole="button"
                    onPress={() => router.push(`/visit/${id}/clarifications`)}
                    style={{
                        padding: 16,
                        borderRadius: 12,
                        backgroundColor: "#e0f5ef",
                        borderWidth: 1,
                        borderColor: "#14836c"
                    }}
                >
                    <Text style={{ color: "#11614f", fontWeight: "700" }}>
                        Clarification requested ·{" "}
                        {requests
                            .filter((r) => r.visitId === id)
                            .reduce((n, r) => n + r.questions.length, 0)}{" "}
                        {requests
                            .filter((r) => r.visitId === id)
                            .reduce((n, r) => n + r.questions.length, 0) === 1
                            ? "question"
                            : "questions"}
                    </Text>
                    <Text style={{ color: "#11614f", marginTop: 4 }}>
                        {visitId
                            ? "Please review questions about your visit"
                            : `Visit #${id} · Tap to review`}
                    </Text>
                </Pressable>
            ))}
        </View>
    );
}
